var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUnderline(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#BCCCD9",
    d: "M12.2 15.4286C9.8795 15.4286 8 13.6203 8 11.3878V6.7619C8 6.34112 8.34112 6 8.7619 6H8.98808C9.40887 6 9.74999 6.34112 9.74999 6.7619V11.3878C9.74999 12.6909 10.8455 13.7449 12.2 13.7449C13.5545 13.7449 14.65 12.6909 14.65 11.3878V6.7619C14.65 6.34112 14.9911 6 15.4119 6H15.6381C16.0589 6 16.4 6.34112 16.4 6.7619V11.3878C16.4 13.6203 14.5205 15.4286 12.2 15.4286ZM8.7619 16.2857H15.8095C16.2303 16.2857 16.5714 16.6268 16.5714 17.0476V17.2381C16.5714 17.6589 16.2303 18 15.8095 18H8.7619C8.34112 18 8 17.6589 8 17.2381V17.0476C8 16.6268 8.34112 16.2857 8.7619 16.2857Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnderline);
export default __webpack_public_path__ + "static/media/underline.46d996c5ad18787419a839b115e9f30a.svg";
export { ForwardRef as ReactComponent };